import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import api from '../../services/api';
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import { DynamicInput } from "../../components/DynamicInput";
import { DynamicSelect } from "../../components/DynamicSelect";
import { DynamicTextareaOnChange } from "../../components/DynamicTextarea";
import { ToggleSwitchFilters } from "../../components/ToggleSwitchFilters";
import DatePicker from 'react-datepicker';
import { StyledForm } from "../../styled-components/StyledForm.style";


export const ModalVisibilidadeAcoes = ({
    processo,
    laudo,
    isOpen,
    setIsOpen,
    aoSalvar
}) => {
    const [isLoading, setisLoading] = useState(false);
    const [loadAcao, setLoadAcao] = useState(null);
    const [valoresDinamicos, setValoresDinamicos] = useState([]);
    const [observacao, setObservacao] = useState("");

    const COR_SINALIZADORES = {
        0: "",
        1: "#10B981",
        2: "#f7cc4d",
        3: "#f16262",
        4: "#aa0505",
    };
    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '55%',
            maxWidth: '70%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        },
    };

    const getLoadAcao = async (idTarefa) => {
        setisLoading(true);
        let list = null;
        try {
            const response = await api.get(`Visibilidade/tarefa/load/acao/${idTarefa}`);
            list = response.data.data;
            setLoadAcao(list);
        } catch (err) {
            console.error(err);
        } finally {
            setisLoading(false);
            return list;
        }
    }

    const onAfterOpen = () => { };
    const closeModal = () => { 
        setValoresDinamicos([]);
        setObservacao("");
        setisLoading(false);
        setIsOpen(false); 
    }

    const renderDynamicComponent = (componente, idPai) => {
        const valorAtual = getValorAtual(componente.idEtapaAcaoAdicionalComponente);

        switch (componente.idTipoComponenteAcaoAdicional) {
            case 'text':
            case 'number':
            case 'email':
            case 'textarea': // Adicionei textarea aqui caso use DynamicInput type="textarea"
                return (
                    <DynamicInput
                        type={componente.tipo || 'text'}
                        label={componente.labelAcaoAdicionalComponente}
                        name={`cmp_${componente.idEtapaAcaoAdicionalComponente}`}
                        placeholder={componente.placeholder || ''}
                        value={valorAtual} 
                        onChange={(e) => handleDynamicChange(componente, e.target.value, idPai)}
                    />
                );
            case 'select':
            case 2:
                const optionsFormatadas = Object.entries(componente.listaTipoComponenteSelect || {}).map(([key, value]) => ({
                    id: key,
                    descricao: value
                })).sort((a, b) => a.descricao.localeCompare(b.descricao));
                return (
                    <>
                        <label style={{ fontSize: '12px', color: '#666', marginBottom: '4px', display: 'block' }}>
                            {componente.labelAcaoAdicionalComponente}
                        </label>
                        <DynamicSelect
                            label={componente.labelAcaoAdicionalComponente}
                            name={`cmp_${componente.idEtapaAcaoAdicionalComponente}`}
                            options={optionsFormatadas} //componente.options
                            keyValue={'id'} 
                            keyLabel={'descricao'} 
                            placeholder={''}
                            valuetext={valorAtual} 
                            classNameCustom="d-none"
                            paramMethod={(current, val) => handleDynamicChange(componente, val, idPai)}
                        />
                    </>
                );
            case 'checkbox':
            case 'toggle':
            case 1: // Supondo que 1 seja o ID do tipo Toggle
                // O valor do toggle deve ser booleano (true/false)
                //const isChecked = !!valorAtual; 
                const isChecked = String(valorAtual) === "true";

                const toggleConfig = {
                    name: `toggle_${componente.idEtapaAcaoAdicionalComponente}`,
                    label: componente.labelAcaoAdicionalComponente,
                    id: componente.idEtapaAcaoAdicionalComponente,
                    status: isChecked,
                    checked: isChecked
                };

                return (
                    <div className="mt-4">
                        <ToggleSwitchFilters 
                            config={toggleConfig} 
                            setStatus={(status) => handleDynamicChange(componente, !isChecked, idPai)} 
                        />
                    </div>
                );
            case 'date':
            case 5:
                //Tenta criar a data baseada no valor atual
                const dataAtualObj = valorAtual ? new Date(valorAtual) : null;

                //Verifica se é uma data válida (evita o crash do Invalid Date)
                const isDataValida = dataAtualObj && !isNaN(dataAtualObj.getTime());
                return (
                    <div className="d-flex flex-column">
                        <label style={{ fontSize: '12px', color: '#666', marginBottom: '4px', display: 'block' }}>{componente.labelAcaoAdicionalComponente}</label>
                        <DatePicker
                            dateFormat="dd/MM/yyyy"
                            locale="pt-BR"
                            className="input-form"
                            placeholderText={''}
                            selected={ isDataValida ? dataAtualObj : null }
                            onChange={(date) => { const valorParaSalvar = date ? date.toISOString() : ""; handleDynamicChange(componente, valorParaSalvar, idPai); }}
                            onChangeRaw={(e) => { if (!e.target.value) { handleDynamicChange(componente, "", idPai); }}}
                        />

                        {/* <DatePicker
                            // Habilita a seleção de hora
                            showTimeSelect 
                            
                            // Define o intervalo de minutos (ex: a cada 15 min)
                            timeIntervals={15} 
                            
                            // Texto do cabeçalho da coluna de horas
                            timeCaption="Hora" 
                            
                            // Formato interno da hora (24h)
                            timeFormat="HH:mm" 
                            
                            // ALTERADO: Adicionei HH:mm para a hora aparecer no input depois de selecionada
                            dateFormat="dd/MM/yyyy HH:mm" 
                            
                            locale="pt-BR"
                            className="input-form"
                            placeholderText={''}
                            selected={valorAtual ? new Date(valorAtual) : null}
                            onChange={(date) => handleDynamicChange(componente, date, idPai)}
                        /> */}
                    </div>
                );

            default:
                return <div className="text-danger">Tipo não suportado: {componente.idTipoComponenteAcaoAdicional}</div>;
        }
    };

    const getValorAtual = (idComponente) => {
        const item = valoresDinamicos.find(x => x.idEtapaAcaoAdicionalComponente === idComponente);
        return item ? item.valorComponente : undefined; 
    };

    const handleDynamicChange = (componente, novoValor, idPai) => {
        setValoresDinamicos(prevState => {
            const index = prevState.findIndex(item => item.idEtapaAcaoAdicionalComponente === componente.idEtapaAcaoAdicionalComponente);

            const novoItem = {
                idEtapaAcaoAdicional: idPai,
                idEtapaAcaoAdicionalComponente: componente.idEtapaAcaoAdicionalComponente,
                tipoComponenteAcaoAdicional: componente.idTipoComponenteAcaoAdicional,
                valorComponente: String(novoValor)
            };

            const novoArray = [...prevState];

            if (index >= 0) {
                novoArray[index] = novoItem;
            } else {
                novoArray.push(novoItem);
            }
            return novoArray;
        });
    };

    // Função para garantir que todos os campos sejam enviados, mesmo os não tocados
    const gerarPayloadCompleto = () => {
        let payloadFinal = [];

        // Varre todos os grupos e componentes originais vindos da API
        loadAcao?.etapa?.acaoAdicional?.forEach(grupo => {
            grupo?.componentes?.forEach(componente => {
                
                // Verifica se este componente já está no state (se o usuário mexeu)
                const itemAlterado = valoresDinamicos.find(
                    x => x.idEtapaAcaoAdicionalComponente === componente.idEtapaAcaoAdicionalComponente
                );

                if (itemAlterado) {
                    // Se o usuário mexeu, usa o valor do state
                    payloadFinal.push(itemAlterado);
                } else {
                    // Se o usuário NÃO mexeu, define um valor padrão baseado no tipo
                    let valorPadrao = "";
                    
                    // Verifica se é Toggle/Checkbox (IDs ou Strings conforme seu switch case)
                    if (['toggle', 'checkbox', 1].includes(componente.idTipoComponenteAcaoAdicional)) {
                        valorPadrao = "false"; // Ou "0", dependendo do que seu back espera
                    }
                    // Adicione outros 'cases' aqui se precisar de valor padrão para text/select (ex: null ou "")

                    payloadFinal.push({
                        idEtapaAcaoAdicional: grupo.idEtapaAcaoAdicional,
                        idEtapaAcaoAdicionalComponente: componente.idEtapaAcaoAdicionalComponente,
                        tipoComponenteAcaoAdicional: componente.idTipoComponenteAcaoAdicional,
                        valorComponente: valorPadrao
                    });

                    console.log('payloadFinal:', payloadFinal);
                }
            });
        });

        return payloadFinal;
    };

    const validarCamposObrigatorios = () => {
        const camposPendentes = [];

        // Varre a estrutura original para checar quem é obrigatório
        loadAcao?.etapa?.acaoAdicional?.forEach(grupo => {
            grupo?.componentes?.forEach(componente => {
                
                if (componente.obrigatorio) {
                    // Busca o valor atual no state
                    const itemState = valoresDinamicos.find(
                        x => x.idEtapaAcaoAdicionalComponente === componente.idEtapaAcaoAdicionalComponente
                    );
                    
                    const valor = itemState ? itemState.valorComponente : "";

                    // Lógica de validação:
                    // 1. Se for nulo ou undefined
                    // 2. Se for string vazia ou apenas espaços
                    // OBS: Toggles/Checkboxes geralmente não entram aqui pois têm valor default "false", 
                    // mas se precisar validar que o checkbox DEVE ser true, a lógica mudaria.
                    if (!valor || (typeof valor === 'string' && valor.trim() === "")) {
                        camposPendentes.push(componente.labelAcaoAdicionalComponente);
                    }
                }
            });
        });

        return camposPendentes;
    };

    const onClickAction = (idTarefa, tipoAcao) => {
        // --- INÍCIO DA VALIDAÇÃO ---
        const erros = validarCamposObrigatorios();

        if (erros.length > 0 && (tipoAcao === 4 || tipoAcao === 5)) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                html: `Os seguintes campos são obrigatórios:<br/><br/><b>${erros.join('<br/>')}</b>`,
                showConfirmButton: true
                //confirmButtonColor: '#EE4B21'
            });
            return; // PARA A EXECUÇÃO AQUI SE TIVER ERRO
        }
        // --- FIM DA VALIDAÇÃO ---

        const dadosDinamicosCompletos = gerarPayloadCompleto();
        
        Swal.fire({
            html: `Deseja Realizar essa Ação?`,
            icon: "info",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            Swal.showLoading();
            setisLoading(true);
            if (result.isConfirmed) {
                try {
                    const headers = {
                        'Content-Type': 'application/json'
                    };

                    //valoresDinamicos
                    const dados = {
                        idTipoAcao: tipoAcao,
                        observacao: observacao,
                        vmVisibilidadeTarefaAcaoAdicionais: dadosDinamicosCompletos
                    };
                    await api.post(`Visibilidade/tarefa/executa/acao/${idTarefa}`, dados, { headers });
                    Swal.fire({
                        title: "Sucesso",
                        text: "Tarefa Executada com Sucesso!",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    }).then(async (result) => {
                        setValoresDinamicos([]);
                        setObservacao("");

                        setisLoading(false);
                        setIsOpen(false);
                        closeModal();

                        if (aoSalvar) { aoSalvar(processo.idProcesso, processo.idTipoServico); }
                    })

                } catch (err) {
                    console.error(err);
                }
            } else {
                setisLoading(false);
            }
        });
    };

    useEffect(() => {
        if(isOpen) {            
            getLoadAcao(processo.idTarefa);
        }
    }, [isOpen])

    return (
    <Modal
        isOpen={isOpen}
        onAfterOpen={onAfterOpen}
        onRequestClose={closeModal}
        contentLabel="Modal Ações"
        style={style}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
    >
        <StyledForm>
            <Flex>
                <Flex.Item className="modal-width">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="pull-left">
                            <p className="modal-title">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="28" height="28" className="me-2">
                                    <path fill={'#999'} d="M415.9 210.5c12.2-3.3 25 2.5 30.5 13.8L465 261.9c10.3 1.4 20.4 4.2 29.9 8.1l35-23.3c10.5-7 24.4-5.6 33.3 3.3l19.2 19.2c8.9 8.9 10.3 22.9 3.3 33.3l-23.3 34.9c1.9 4.7 3.6 9.6 5 14.7 1.4 5.1 2.3 10.1 3 15.2l37.7 18.6c11.3 5.6 17.1 18.4 13.8 30.5l-7 26.2c-3.3 12.1-14.6 20.3-27.2 19.5l-42-2.7c-6.3 8.1-13.6 15.6-21.9 22l2.7 41.9c.8 12.6-7.4 24-19.5 27.2l-26.2 7c-12.2 3.3-24.9-2.5-30.5-13.8l-18.6-37.6c-10.3-1.4-20.4-4.2-29.9-8.1l-35 23.3c-10.5 7-24.4 5.6-33.3-3.3l-19.2-19.2c-8.9-8.9-10.3-22.8-3.3-33.3l23.3-35c-1.9-4.7-3.6-9.6-5-14.7s-2.3-10.2-3-15.2l-37.7-18.6c-11.3-5.6-17-18.4-13.8-30.5l7-26.2c3.3-12.1 14.6-20.3 27.2-19.5l41.9 2.7c6.3-8.1 13.6-15.6 21.9-22l-2.7-41.8c-.8-12.6 7.4-24 19.5-27.2l26.2-7zM448.4 340a44 44 0 1 0 .1 88 44 44 0 1 0 -.1-88zM224.9-45.5l26.2 7c12.1 3.3 20.3 14.7 19.5 27.2l-2.7 41.8c8.3 6.4 15.6 13.8 21.9 22l42-2.7c12.5-.8 23.9 7.4 27.2 19.5l7 26.2c3.2 12.1-2.5 24.9-13.8 30.5l-37.7 18.6c-.7 5.1-1.7 10.2-3 15.2s-3.1 10-5 14.7l23.3 35c7 10.5 5.6 24.4-3.3 33.3L307.3 262c-8.9 8.9-22.8 10.3-33.3 3.3L239 242c-9.5 3.9-19.6 6.7-29.9 8.1l-18.6 37.6c-5.6 11.3-18.4 17-30.5 13.8l-26.2-7c-12.2-3.3-20.3-14.7-19.5-27.2l2.7-41.9c-8.3-6.4-15.6-13.8-21.9-22l-42 2.7c-12.5 .8-23.9-7.4-27.2-19.5l-7-26.2c-3.2-12.1 2.5-24.9 13.8-30.5l37.7-18.6c.7-5.1 1.7-10.1 3-15.2 1.4-5.1 3-10 5-14.7L55.1 46.5c-7-10.5-5.6-24.4 3.3-33.3L77.6-6c8.9-8.9 22.8-10.3 33.3-3.3l35 23.3c9.5-3.9 19.6-6.7 29.9-8.1l18.6-37.6c5.6-11.3 18.3-17 30.5-13.8zM192.4 84a44 44 0 1 0 0 88 44 44 0 1 0 0-88z"/></svg>
                                    { loadAcao?.nomeEtapa || "-" } - <span style={ {color: COR_SINALIZADORES[loadAcao?.tipoSinalizacao?.idTipoSinalizacao || 0]}}>{loadAcao?.tipoSinalizacao?.tipoSinalizacaoDescricao || '-'}</span></p>
                        </div>
                        <div className="pull-right">
                            <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                        </div>
                    </div>
                </Flex.Item>
            </Flex>

            {isLoading ? 
            (
            <div className="text-center">
                <div className="text-items-center">
                    <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                    <div className="mt-2">
                        <strong style={{ color: "#EE4B21" }}>Aguarde enquanto validamos as informações</strong>
                    </div>
                </div>
            </div>
            ) : (
                <>
                <div className="row mb-2" style={{ fontSize: "14px" }}>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Processo</span><br/>{ loadAcao?.processo?.processoSigla || "-" }</div>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Líder</span><br/>{ loadAcao?.processo?.liderProcesso || "-" }</div>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Cliente</span><br/>{ loadAcao?.processo?.cliente || "-" }</div>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Segurado</span><br/>{ loadAcao?.processo?.segurado || "-" }</div>
                </div>
                <div className="row" style={{ fontSize: "14px" }}>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Disciplina</span><br/>{ laudo.disciplina }</div>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Responsável</span><br/>{ loadAcao?.nomeUsuarioResponsavel || "-" }</div>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Criação</span><br/>{ new Date(loadAcao?.dataCriacao).toLocaleDateString('pt-BR') }</div>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Prazo</span><br/>{ new Date(loadAcao?.dataPrazo).toLocaleDateString('pt-BR') }</div>

                </div>
                <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                { loadAcao?.etapa?.acaoAdicional?.map((itemCampo, indexGroup) => (
                    <div key={indexGroup} className="mb-3">
                        <div className="row">
                            {itemCampo?.componentes?.map((componente, indexComp) => (
                                // Aqui definimos o tamanho da coluna. 
                                // Se o JSON tiver 'width' ou 'col', use. Se não, col-md-3 é um bom padrão.
                                <div 
                                    className="col-3 " 
                                    key={componente.id || componente.key || indexComp}
                                >
                                    {renderDynamicComponent(componente, itemCampo.idEtapaAcaoAdicional)}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
                <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>
                <div className="row align-items-center justify-content-center w-100">
                    <div className="col text-center">
                        <DynamicTextareaOnChange 
                            placeholder={"Observações"} 
                            label={"Observações"} 
                            name={"observacao"}
                            valuetext={observacao}
                            onChange={(e) => setObservacao(e.target.value)}
                        />
                    </div>
                </div>
                <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                <Flex>
                    <Flex.Item>
                        <div className="row align-items-center justify-content-center">
                            { loadAcao?.etapa?.configuracao?.habilitaAcaoIniciar && ( 
                                <>
                                <div className="col text-center">
                                    <input 
                                        className='default-button-red' 
                                        value={'Iniciar'} 
                                        type="button" 
                                        onClick={onClickAction.bind(this, loadAcao?.idTarefa, 2)}/>
                                </div>
                                </>
                            ) } 

                            { loadAcao?.etapa?.configuracao?.habilitaAcaoDispensar && ( 
                                <>
                                <div className="col text-center">
                                    <input 
                                        className='default-button-red' 
                                        value={'Dispensar'} 
                                        type="button"
                                        onClick={onClickAction.bind(this, loadAcao?.idTarefa, 3)}/>
                                </div>
                                </>
                            ) } 

                            { loadAcao?.etapa?.configuracao?.habilitaAcaoReprovar && ( 
                                <>
                                <div className="col text-center">
                                    <input 
                                        className='default-button-red' 
                                        value={'Reprovar'} 
                                        type="button"
                                        onClick={onClickAction.bind(this, loadAcao?.idTarefa, 6)}/>
                                </div>
                                </>
                            ) } 

                            { loadAcao?.etapa?.configuracao?.habilitaAcaoConcluir && ( 
                                <>
                                <div className="col text-center">
                                    <input 
                                        className='default-button-blue' 
                                        value={'Concluir'} 
                                        type="button"
                                        onClick={onClickAction.bind(this, loadAcao?.idTarefa, 4)}/>
                                </div>
                                </>
                            ) } 
                            
                            { loadAcao?.etapa?.configuracao?.habilitaAcaoAprovar && ( 
                                <>
                                <div className="col text-center">
                                    <input 
                                        className='default-button-blue' 
                                        value={'Aprovar'} 
                                        type="button"
                                        onClick={onClickAction.bind(this, loadAcao?.idTarefa, 5)}/>
                                </div>
                                </>
                            ) } 
                            
                        </div>
                    </Flex.Item>
                </Flex>
                </>
            )}
        </StyledForm>
    </Modal>
    );
};